import React from "react";

export default function useInitPortalizedModalContext() {
  const [modal, setModal] = React.useState(false);
  const [content, setContent] = React.useState({});

  const setModalContent = (title, content) => setContent({title, content});
  const openModal = () => setModal(true);
  const closeModal = () => setModal(false)

  return { modal, openModal, closeModal, content, setModalContent };
};
